'use client';
import { useEffect, useRef } from 'react';
import lottie from 'lottie-web';
import clsx from 'clsx';
import { Image } from '~/components';

import styles from './ExhibitionItem.module.css';

type Props = {
  imageUrl: string;
};
export const ExhibitionItem = ({ imageUrl }: Props) => {
  const lottieRef = useRef<HTMLDivElement | null>(null);

  const isLottieFile = (url: string) => {
    const regex = /(\.){1}json$/g;
    return regex.test(url);
  };
  const isLottie = isLottieFile(imageUrl);

  useEffect(() => {
    if (!imageUrl || !isLottie) return;

    const animation = lottie.loadAnimation({
      container: lottieRef.current as HTMLDivElement,
      loop: true,
      autoplay: true,
      path: imageUrl,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    });

    return () => {
      animation?.destroy();
    };
  }, [imageUrl, isLottie]);
  return (
    <>
      {isLottieFile(imageUrl) ? (
        <div ref={lottieRef} className={clsx([styles.item, styles.lottie])} />
      ) : (
        <Image
          width={335}
          height={98}
          unoptimized
          src={imageUrl}
          alt="탑 배너"
          priority
          className={clsx([styles.item, styles.img])}
        />
      )}
    </>
  );
};
